import { render, staticRenderFns } from "./SocialNetworkForm.vue?vue&type=template&id=390a1a89&scoped=true&"
import script from "./SocialNetworkForm.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=390a1a89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a1a89",
  null
  
)

export default component.exports